import React from "react"
import SectionInput from "./section_input"
import TransformRow from "./transform_row"
import PreviewSections from "./preview_sections"
import Ad from "./ad"
import styled from "@emotion/styled"

export default class SectionContent extends React.PureComponent {
  getTransforms(){
    return this.props.data.textTransforms.nodes;
  }
  hasPreviewSections(){
    return this.props.data.textStyle && this.props.data.textStyle.hasPreviewImages;
  }
  getHelloTextString(){
    let str = this.props.data.helloTextString.string;
    if (this.props.hello_text_string) {
      str = this.props.hello_text_string;
    }
    return str;
  }
  render() {
    let in_section_ads = {
      12 : {
        ez: 120,
        ads: 6785619291,
        fs: "yaytext_inlist_Mid"
      },
      24 : {
        ez: 103,
        ads: 2215818890,
        fs: "yaytext_inlist_btf"
      },
      // 44 : {
      //   ez: 121,
      //   ads: 4045149154
      // }
    }
    const {textStyle} = this.props.data;
    return (
      <SectionWrapper>
        <SectionInput {...this.props} hello_text_string={this.getHelloTextString()}/>
        <StyleSections className="style_sections">
          {this.getTransforms().map((transform, i) => {
            return <React.Fragment key={`transform_${i}`}>
                <TransformRow
                {...this.props}
                transform={transform}
                />
                { !this.props.pageContext.textStyleId
                  && in_section_ads[i]
                  && <div className="section hasAd">
        						<div className="section_inner">
                      <Ad
                        ezoic_placeholder_id={in_section_ads[i].ez}
                        adsense_slot={in_section_ads[i].ads}
                        adsense_format="auto"
                        freestarPlacementName={in_section_ads[i].fs}
                        />
                    </div>
                  </div>
                }
              </React.Fragment>
          })}
        </StyleSections>
        { textStyle && textStyle.moreInfoCtd &&
          <MoreInfoSection className="section">
            <div className="section_inner" dangerouslySetInnerHTML={{
                __html: textStyle.moreInfoCtd
              }}>
            </div>
          </MoreInfoSection>
        }
        {
          textStyle && textStyle.relatedDescription && 
          <>
            <div className="section">
              <div className="section_inner">
                <h3>Related Styles</h3>
                <p>{textStyle.relatedDescription}</p>
              </div>
            </div>
            <StyleSections className="style_sections">
            {textStyle.relatedTextTransforms.map((transform, i) => {
              return <React.Fragment key={`transform_${i}`}>
                  <TransformRow
                  {...this.props}
                  forceRowLink={true}
                  transform={transform}
                  />
                </React.Fragment>
            })}
            </StyleSections>
            <div className="section">
              <div className="section_inner" dangerouslySetInnerHTML={{
                  __html: textStyle.relatedCtd
                }}>
              </div>
            </div>
          </>
        }
        {
          this.hasPreviewSections() &&
          <div className="section hasAd">
            <div className="section_inner">
              <Ad
                ezoic_placeholder_id="106"
                adsense_slot="8621445146"
                adsense_format="auto"
                freestarPlacementName="yaytext_inlist_Mid"
                />
            </div>
          </div>
        }
        {
          this.hasPreviewSections()
          && <PreviewSections transforms={this.getTransforms()} {...this.props} />
        }
      </SectionWrapper>
    )
  }
}

const MoreInfoSection = styled("div")`
background: rgb(96, 184, 195)
`

const SectionWrapper = styled("div")`
.site_news {
  background: #6DBDC9;
  p {
    margin: 0;
    font-size: 16px;
  }
}
`

const StyleSections = styled("div")`
font-size: 20px;
.section:nth-of-type(even) { background: #6DBDC9; }
`
